module.exports = __webpack_public_path__ + "images/assets/7562c6f1516d8b1914d3e76a56aa2136.svg";